module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_4-a1aeeb9be0cedad0f2aaf0c27997b53b.svg";